import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import ShopCarousel from "./ShopCrousel";
import TcardsCrousel from "../Cards/TcardsCrousel";
import TInvitationCard from "../Cards/TInvitationCard";

const ShopByCategory = () => {
  return (
    <Box>
      <Text
        className="oswald-font"
        fontWeight={"bold"}
        fontSize={{ md: "25px", base: "20px" }}
        letterSpacing={0}
        opacity={1}
        mt={{ md: 5, base: "60px" }}
        mb={2}
      >
        Trending Cards
      </Text>
      <Flex
        justifyContent={"space-between"}
        flexDirection={{ md: "row", base: "column" }}
        gap={5}
        mb={10}
      >
        <Box w={{ md: "49%", base: "100%" }} bg={"#1498D2"}>
          <Flex mt={2} gap={2} alignItems={"center"}>
            <Box w={{ md: "10%" }} display={{ md: "block", base: "block" }}>
              <Text
                className="vertical-text oswald-font"
                fontSize={{ md: 38, base: 42 }}
                fontWeight={"bold"}
                color={"white"}
                letterSpacing={3}
                mt={-6}
              >
                GREETINGS
              </Text>
            </Box>
            <Flex w={{ md: "90%", base: "75%" }} pr={2}>
              <TcardsCrousel />
            </Flex>
          </Flex>
        </Box>
        <Box
          w={{ md: "49%", base: "100%" }}
          bg={"#9554DF"}
          // h={{ md: 255, base: 350 }}
        >
          <Flex
            mt={2}
            gap={2}
            alignItems={"center"}
            display={{ md: "flex", base: "none" }}
          >
            <Box w={{ md: "10%" }} display={{ md: "block", base: "block" }}>
              <Text
                className="vertical-text oswald-font"
                fontSize={{ md: 35, base: 42 }}
                fontWeight={"bold"}
                color={"white"}
                mt={-6}
                letterSpacing={2}
              >
                INVITATIONS
              </Text>
            </Box>
            <Flex w={{ md: "90%", base: "75%" }} pr={2}>
              <TInvitationCard />
            </Flex>
          </Flex>
        </Box>
      </Flex>
      <Flex alignItems={"center"} justifyContent={"space-between"} mt={-5}>
        <Text
          className="oswald-font"
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={{ md: "25px", base: "20px" }}
          letterSpacing={"0px"}
          opacity={1}
        >
          Shop By Category
        </Text>
      </Flex>
      <Box mt={3}>
        <ShopCarousel />
      </Box>
    </Box>
  );
};

export default ShopByCategory;
